<template>
  <span>
    <span v-for="(standard,standard_id) in currentStandard" :key="standard_id">
      <span>{{ getStandardName(standard) }}</span>
      <span v-if="standard_id < currentStandard.length - 1">&nbsp; / &nbsp;</span>
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/store/modules/standards";

export default {
  props: {
    standard: {
      type: [Array, String],
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    getStandardName(standard_id) {
      const standard = this.getStandard(standard_id);
      return standard ? standard.name : "";
    }
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getStandard]),
    currentStandard() {
      if (this.standard instanceof Array) {
        return this.standard;
      } else {
        return [this.standard];
      }
    }
  }
};
</script>
